module.exports = {
      id: "comm-lifestyle-usage",
      viewBox: "0 0 294 59.387",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-lifestyle",
      toString: function () {
        return this.url;
      }
    }